


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaUtensils, FaConciergeBell, FaStore, FaBuilding, FaShoppingBasket } from "react-icons/fa";
import Cloudbannerall from "./Cloudbannerall";
import "./Mainladdingpage.css";
import Mainnavbar from './Mainnavbar';
import Cateringbanner from './Cateringbanner.js';
import Franchiessbanner from './Franchiessbanner';
import Banquethallbanner from './Banquethallbanner';
import menu1 from "./download.jpg";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Logisticsbanner from "./Logisticsbanner"
import Mainlandingadvertise from "./Mainlandingadvertise"

const Subscriptionpage = () => {
    const [activeFilter, setActiveFilter] = useState("Food & Beverages");
    const [coupons, setCoupons] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const isMobile = window.innerWidth <= 768;
    const dishImages = {
        1: { image: menu1 },
        2: { image: menu1 },
        3: { image: menu1 },
    };
    useEffect(() => {
        setCoupons([
            { code: "PIZZA50", discountPercentage: 50, dishId: 1 },
            { code: "BURGER30", discountPercentage: 30, dishId: 2 },
            { code: "DEL99", discountPercentage: 20, dishId: 3 },
        ]);
    }, []);



    const renderContent = () => {
        switch (activeFilter) {
            case "Food & Beverages":
                return <Cloudbannerall />;
            // case "Catering & Services":
            //     return <Cateringbanner />;
            // case "Fresh & Grocery":
            //     return <Franchiessbanner />;
            // case "Logistics & Supply":
            //     return <Logisticsbanner />;

            case "Banquet Hall":
                return <Banquethallbanner />;
            default:
                return <Cloudbannerall />;
        }
    };

    const filterOptions = [
        { name: "Food & Beverages", icon: <FaUtensils /> },
        // { name: "Catering & Services", icon: <FaConciergeBell /> },
        // { name: "Fresh & Grocery", icon: <FaShoppingBasket /> },
        // { name: "Logistics & Supply", icon: <LocalShippingIcon /> },
        // Grocery category
        // { name: "Banquet Hall", icon: <FaBuilding /> },
    ];

    return (
        <div>
            <Mainnavbar />
            <div style={{ justifyContent: 'center' }} className="container-fluid main-container">
                <div className="row">
                    {/* Sidebar */}
                    <div className="col-lg-2 col-md-12 col-sm-12 sidebar">
                        <ul className="filter-list">
                            {filterOptions.map((item) => (
                                <li
                                    key={item.name}
                                    className={`filter-item ${activeFilter === item.name ? "active" : ""}`}
                                    onClick={() => setActiveFilter(item.name)}
                                >
                                    <span className="icon">{item.icon}</span>
                                    <span className="text">{item.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Content */}
                    <div
                        className="col-lg-8 col-md-12 col-sm-12 content-area"
                        style={{ height: "85vh", overflow: "auto", scrollbarWidth: "none", }}
                    >

                        <div style={{ padding: "15px", marginTop: "50px" }} className="main-banner-mobile">{renderContent()}</div>
                    </div>

                    {/* Right Panel (Hidden on Mobile) */}
                    <div className="col-lg-2 col-md-12 col-sm-12 right-panel">
                        <div className="right-panel-inner">

                            <Mainlandingadvertise />


                        </div>
                    </div>
                </div>
            </div>

            {/* Internal CSS for responsiveness */}
            <style>
                {`
          .sidebar {
            padding: 15px;
          }

          .filter-list {
            list-style: none;
            padding: 0;
          }

          .filter-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px;
            cursor: pointer;
            border-radius: 6px;
          }

          .filter-item.active {
            background: #b15cd6;
            color: #fff;
          }

          .filter-item:hover {
            background: #f2e6f9;
          }

          /* Hide right panel on tablets and below */
          @media (max-width: 991px) {
            .right-panel {
              display: none !important;
            }
          }

          /* Sidebar full width on mobile */
          @media (max-width: 768px) {
            .sidebar {
              width: 100% !important;
              margin-bottom: 10px;
              background: #fafafa;
              border-bottom: 1px solid #ddd;
            }
            .filter-item {
              justify-content: flex-start;
            }
            .content-area {
              margin-top: 15px;
            }
              .main-banner-mobile{
              width:96vw !important;
              }
              .main-container{
              margin-top:15px !important;
              }
          }
       
        `}
            </style>
        </div>
    );
};

export default Subscriptionpage;

